import { render, staticRenderFns } from "./Tickets.vue?vue&type=template&id=c43bf5aa&scoped=true&"
import script from "./Tickets.vue?vue&type=script&lang=ts&"
export * from "./Tickets.vue?vue&type=script&lang=ts&"
import style0 from "../../assets/css/helpdesk/tickets.css?vue&type=style&index=0&id=c43bf5aa&prod&scoped=true&lang=css&"
import style1 from "./Tickets.vue?vue&type=style&index=1&id=c43bf5aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43bf5aa",
  null
  
)

export default component.exports